import { Loader } from 'react-feather';
import { DefaultTheme } from 'styled-components';

import theme from 'styles/theme';

import * as S from './styles';

export type LoadingSpinnerProps = {
  color?: keyof DefaultTheme['colors'];
};

const LoadingSpinner = ({ color = 'globalWhite100' }: LoadingSpinnerProps) => {
  return (
    <S.Container>
      <Loader color={theme.colors[color]} />
    </S.Container>
  );
};

export default LoadingSpinner;
